module.exports = __webpack_public_path__ + "img/flag-grey.26909de3.svg";